import { ClipProvider } from '@/@types/graphql-types';
import { TrailerClip } from '@/interfaces/trailerClip';

export const VideoPlayersTrackingIds: Record<TrailerClip['provider'], number> = {
	[ClipProvider.Youtube]: 1,
	[ClipProvider.Videobuster]: 2,
	[ClipProvider.Dailymotion]: 3,
	PLEX: 4,
	[ClipProvider.Justwatchtv]: 5,
	JUSTWATCH_TV: 5,
	OTT: 6,
};
